<template>
  <div class="upload">
    <form ref="form" enctype="multipart/form-data" class="form" @submit="prevent">
      <input ref="file" type="file" :disabled="disabled" accept="image/*" class="input" @change="uploadFile" />
      <div class="design" @click="$refs.file.click()">
        <slot>
          <div class="message">Drag to upload or choose a file</div>
        </slot>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',
  props: {
    fileSizeLimit: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadedFile: null,
      uploadedImageUrl: null,
    };
  },
  methods: {
    uploadFile(e) {
      this.$emit('uploadStarted');
      if (!e.target.files[0]) {
        return;
      }

      [this.uploadedFile] = e.target.files;

      if (this.getSizeInMb(e.target.files[0].size) > this.fileSizeLimit) {
        this.$emit('fileSizeError', this.fileSizeLimit);
        this.$refs.form.reset();
        return;
      }

      // if(this.uploadedFile.type.indexOf('jpeg/png') === -1){
      //   this.$emit('fileTypeError', this.uploadedFile.type);
      //   return;
      // }

      if (this.uploadedFile.type.includes('image')) {
        this.uploadedImageUrl = URL.createObjectURL(this.uploadedFile);
      }

      this.$emit('uploadComplete', this.uploadedImageUrl, this.uploadedFile);
      this.$refs.form.reset();
    },
    getSizeInMb(bytes) {
      return parseFloat((bytes / 1024 ** 2).toFixed(2));
    },
    prevent(e) {
      e.preventDefault();
    },
  },
};
</script>

<style scoped lang="scss">
.upload {
  display: inline-block;
  // width: 100%;
  // height: 100%;

  position: relative;
}

.form {
  position: relative;
}

.input {
  border: 0;
  position: absolute;
  background: #fff;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}

.design {
  position: relative;
}
</style>
